'use client';
'use strict';

var classes = {"input":"m-6fa5e2aa"};

module.exports = classes;
//# sourceMappingURL=PickerInputBase.module.css.cjs.map
